import AccountCircle from '@mui/icons-material/AccountCircle'
import LogoutIcon from '@mui/icons-material/Logout'
import {
  IconButton,
  Menu, PopoverOrigin
} from '@mui/material'
import SettingsIcon from '@mui/icons-material/Settings'
import { styled } from '@mui/material/styles'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { ReactNode, useCallback, useState } from 'react'
import { Logout, useAuthProvider, useGetIdentity, useTranslate } from 'react-admin'
import { getUserName } from '../utils/userDetails'
import { useNavigate } from 'react-router-dom'

const AnchorOrigin: PopoverOrigin = {
  vertical: 'bottom',
  horizontal: 'right',
}

const TransformOrigin: PopoverOrigin = {
  vertical: 'top',
  horizontal: 'right',
}

export const UserMenu = (props: UserMenuProps): JSX.Element | null => {
  const [anchorEl, setAnchorEl] = useState(null)
  const translate = useTranslate()
  const { isLoading, identity } = useGetIdentity()
  const userName = getUserName()
  const navigate = useNavigate()
  const authProvider = useAuthProvider()

  const {
    children = !!authProvider ? <Logout /> : null,
    className,
    label = 'ra.auth.user_menu',
    icon = defaultIcon,
  } = props

  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  const handleMenu = event => setAnchorEl(event.currentTarget)
  const handleClose = useCallback(() => setAnchorEl(null), [])
  if (!children) return null
  const open = Boolean(anchorEl)

  return (
    <Root className={clsx(classes.root, className)}>
      <IconButton
        aria-label={translate('settings.title')}
        color="inherit"
        onClick={() => navigate('/settings')}
      >
        <SettingsIcon sx={{ color: '#fff' }} />
      </IconButton>
      <IconButton
        aria-label={label && translate(label, { _: label })}
        aria-haspopup={true}
        color="inherit"
        onClick={handleMenu}
      >
        <AccountCircle sx={{ color: '#fff'}}/>
      </IconButton>
      <IconButton
        aria-label={label && translate(label, { _: label })}
        aria-haspopup={true}
        color="inherit"
        // onClick={handleMenu}
      >
        <LogoutIcon sx={{ color: '#fff'}}/>
      </IconButton>
      <Menu
        id="menu-appbar"
        disableScrollLock
        anchorEl={anchorEl}
        anchorOrigin={AnchorOrigin}
        transformOrigin={TransformOrigin}
        open={open}
        onClose={handleClose}
      >
        {children}
      </Menu>
    </Root>
  )
}

const defaultIcon = <AccountCircle />

interface UserMenuProps {
  children?: ReactNode;
  className?: string;
  icon?: ReactNode;
  label?: string;
}

UserMenu.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.object,
  label: PropTypes.string,
  icon: PropTypes.node,
}

const PREFIX = 'xxllncUserMenu'

const classes = {
  root: `${PREFIX}-root`,
  button: `${PREFIX}-button`,
  avatar: `${PREFIX}-avatar`,
}

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {},
  [`& .${classes.button}`]: {
    color: '#fff!important',
  },
  [`& .${classes.avatar}`]: {
    width: theme.spacing(4),
    height: theme.spacing(4),
  },
  ['& span']: {
    marginRight: '5px',
  },
}))
